export const RESET_PASSWORD = 'RESET_PASSWORD';
export const PASSWORD_INPUT_MODIFIED = 'PASSWORD_INPUT_MODIFIED';
export const TOGGLE_CONNECTION_NOTIFICATIONS = 'TOGGLE_CONNECTION_NOTIFICATIONS';
export const HYDRATE_FROM_SERVER = 'HYDRATE_FROM_SERVER';
export const ADD_TEMP_USER = 'ADD_TEMP_USER';
export const DELETE_TEMP_USER = 'DELETE_TEMP_USER';
export const TEMP_USER_PROP_MODIFIED = 'TEMP_USER_PROP_MODIFIED';
export const ADD_NEW_USERS = 'ADD_NEW_USERS';
export const CLEAR_TEMP_USERS = 'CLEAR_TEMP_USERS';
export const CLEAR_ADD_USER_MESSAGE = 'CLEAR_ADD_USER_MESSAGE';
export const USER_APPROVED_OR_REJECTED = 'USER_APPROVED_OR_REJECTED';
export const USER_DISABLED = 'USER_DISABLED';
export const USER_DELETED = 'USER_DELETED';
export const EDIT_USER_UPDATED = 'EDIT_USER_UPDATED';
export const EDIT_USER_PROP_MODIFIED = 'EDIT_USER_PROP_MODIFIED';
export const EDIT_USER_SAVED = 'EDIT_USER_SAVED';
export const CLEAR_EDIT_USER_MESSAGE = 'CLEAR_EDIT_USER_MESSAGE';
export const CONFIRMED_DISASSOCIATE_SECONDARY_EMAIL = 'CONFIRMED_DISASSOCIATE_SECONDARY_EMAIL';
export const ADD_SECONDARY_EMAIL = 'ADD_SECONDARY_EMAIL';
export const RESEND_CONFIRMATION_SECONDARY_EMAIL = 'RESEND_CONFIRMATION_SECONDARY_EMAIL';
export const RESEND_CONFIRMATION_LINK_USER_SETTINGS = 'RESEND_CONFIRMATION_LINK_USER_SETTINGS';
export const CLEAR_MANAGE_USERS_MESSAGE = 'CLEAR_MANAGE_USERS_MESSAGE';
export const START_ADDING_NEW_USER = 'START_ADDING_NEW_USER';
export const UPDATE_SETTINGS_PROP = 'UPDATE_SETTINGS_PROP';



// WEBPACK FOOTER //
// ./src/app/stores/settings/settings-constants.js